module.exports = __webpack_public_path__ + "static/media/EAI-04.d22bb006.jpg";